import { FunctionComponent, useState } from 'react';
import * as vp from 'vopay';
import { convertToOptions } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/UI';
import useCountryLabels from '@/hooks/useCountryLabels';

const { Box, Select, TextField } = vp;

type SearchValues = { searchTerm: string; country: string };

type SearchAccountsProps = {
  countries: string[];
  onSearch: (values: SearchValues) => void;
};

type FC = FunctionComponent<SearchAccountsProps>;

const SubAccountSearchForm: FC = ({ countries, onSearch }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.SubAccounts.SearchForm' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { resolveCountryLabel } = useCountryLabels();
  const [searchTerm, setSearchTerm] = useState('');
  const [country, setCountry] = useState('');

  const countryObject = Object.fromEntries(
    countries.map((curr): [string, string] => {
      if (curr === '') {
        return ['', tGlobal('all')];
      }

      return [curr, resolveCountryLabel(curr)];
    }),
  );

  const countryOptions = {
    '': t('selectCountryOption', { defaultValue: 'Select Country' }),
    ...countryObject,
  };

  const handleSearch = () => {
    onSearch({ searchTerm, country });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
      <Box width="150px">
        <Select
          version="2"
          placeholder={t('countryPlaceholder')}
          options={convertToOptions(countryOptions)}
          name="country"
          onBlur={() => {}}
          onChange={(e) => setCountry(e.target.value)}
          value={country}
        />
      </Box>
      <TextField
        key="Keyword"
        name="keyword"
        placeholder={t('keywordPlaceholder')}
        variant="outlineShadow"
        onBlur={() => {}}
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
      />
      <Button id="sub-accounts-search" type="button" colorScheme="primary" size="small" onClick={handleSearch}>
        {t('searchButton')}
      </Button>
    </div>
  );
};

export default SubAccountSearchForm;
